const OnboardingScreenSpacing = { mt: { xs: 2, sm: 8 } };
export default OnboardingScreenSpacing;
